import React from 'react';
import moment from 'moment';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import BlockIcon from '@material-ui/icons/Block';
import PauseCircleFilledIcon from '@material-ui/icons/PauseCircleFilled';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { capitalizeFirstLetter } from '../../../../utils';
import { SESSION_STATUS, sessionStatusConfig } from '../constants';

// Shared by the Upload Progress table and the session files dialog

// Data room section in the folder URL, by the folder's category (same mapping as global search).
// Sessions don't say which section their folder is in yet, so 'technical' is the fallback.
const FOLDER_SECTIONS = { 1: 'technical', 2: 'discrepancy', 3: 'contract', 4: 'inspection', 5: 'maintanence' };
export const folderLink = (session) => (session.asset_type && session.asset_slug && session.folder_uuid ?
  `/${session.asset_type}/${session.asset_slug}/data-room/${FOLDER_SECTIONS[session.category] || 'technical'}/${session.folder_uuid}` : null);

const statusIcons = {
  [SESSION_STATUS.INTERRUPTED]: <WarningIcon />,
  [SESSION_STATUS.PAUSED]: <PauseCircleFilledIcon />,
  [SESSION_STATUS.ACTIVE]: <CloudUploadIcon />,
  [SESSION_STATUS.COMPLETED]: <CheckCircleIcon />,
  [SESSION_STATUS.FAILED]: <ErrorIcon />,
  [SESSION_STATUS.CANCELLED]: <BlockIcon />,
};

// Unknown statuses from the API still render, labelled with the raw value
export const getConfig = (status) => sessionStatusConfig[status] || { label: capitalizeFirstLetter((status || 'Unknown').toLowerCase()), color: '#64748b', background: '#edf1f7', bar: '#94a3b8' };

export const formatTime = (value) => moment(value).format('MMM DD, YYYY hh:mm A');

export const formatDuration = (seconds) => {
  if (!seconds || !isFinite(seconds)) return null;
  if (seconds < 60) return `${Math.max(1, Math.round(seconds))}s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
};

export const StatusChip = ({ status }) => {
  const config = getConfig(status);
  return (
    <span className="upload-progress__status-chip" style={{ color: config.color, background: config.background }}>
      {statusIcons[status] || null} {config.label}
    </span>
  );
};
